import { render, staticRenderFns } from "./modal-yes-no.vue?vue&type=template&id=63bbd5f4"
import script from "./modal-yes-no.vue?vue&type=script&lang=js"
export * from "./modal-yes-no.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports